/* import __COLOCATED_TEMPLATE__ from './activate-country-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();